import { COLORS } from '@btime/constants'
import { head, prop } from 'ramda'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { SmallText, Title } from '../../../../../../../packages/kiti/components/presentation/Text'
import { canRenderInputForType } from '../_helpers/hideInputForType'
import { useChecklistFormActions, useSelectedQuestion } from '../../../../_form/ChecklistFormHandler'
import ConditionInput from '../../../../../../../containers/dynamic/conditions/ConditionInput'
import Link from '../../../../../../../packages/kiti/components/actions/Link'
import Separator from '../../../../../../../packages/kiti/components/helpers/Separator'
import { HorizontalLine } from '../../../../../../../components/shapes/Line'

const NonComplianceSection = () => {
  const { t } = useTranslation('editChecklist')
  const { handleSelectedQuestionChange } = useChecklistFormActions()
  const selectedQuestion = useSelectedQuestion()

  const shouldRender = canRenderInputForType(selectedQuestion.questionType.name)
  const shouldRenderNonCompliance = shouldRender('nonComplianceConditions')

  if (!shouldRenderNonCompliance) return false

  const condition = head(selectedQuestion.nonComplianceConditions || [])
  const value = prop('value', condition)

  return (
    <>
      <Separator weight={6} />

      <Title size="h6" color={COLORS.dark4}>
        {t('isNonComplianceWhenAnswerIs')}
      </Title>
      <HorizontalLine thin lineColor={COLORS.light2} />
      <Separator weight={2} />

      <ConditionInput
        value={condition}
        type={selectedQuestion.questionType?.name}
        onChange={cond => handleSelectedQuestionChange('nonComplianceConditions', [cond])}
        field="value"
        options={selectedQuestion.options}
        {...selectedQuestion.data}
      />

      <Separator weight={4} />

      {![null, undefined].includes(value) && (
        <Link onClick={() => handleSelectedQuestionChange('nonComplianceConditions', undefined)}>
          <SmallText bold color={COLORS.red}>
            {t('removeConfiguration')}
          </SmallText>
        </Link>
      )}
    </>
  )
}

export default NonComplianceSection
